<template>
    <div>
        <h1 class="mb-8 font-bold text-3xl">
            <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('admin.roles')">Admin Roles</inertia-link>
            <span class="text-indigo-400 font-medium">/</span>
            Update Role
        </h1>

        <form @submit.prevent="submit">
            <div class="lg:w-6/12">
                <text-input label="Role Title" v-model="form.title"/>

                <div class="px-4 my-4 bg-white p-2 rounded">
                    <div class="flex items-center justify-between py-3">
                        <div class="text-sm font-medium">Super Role</div>
                        <toggle v-model="form.super_role" />
                    </div>
                    <p class="text-sm text-gray-600" v-if="form.super_role">A super role gives full access</p>

                    <div v-if="!form.super_role">
                        <p class="text-sm font-bold my-3">Available Admin Permissions</p>
                        <div class="flex items-center justify-between border-t py-3" v-for="(permission, permKey) in permissions">
                            <div class="text-sm font-medium">{{ permission }}</div>
                            <toggle v-model="form.permissions[permKey]" />
                        </div>
                    </div>
                </div>

                <div class="px-8 py-4 bg-gray-100 border-t border-gray-200 flex justify-end items-center">
                    <loading-button :loading="sending" class="btn-primary" type="submit">Update Role</loading-button>
                </div>

            </div>
        </form>
    </div>
</template>

<script>
  import Icon from '@/Shared/Icon'
  import Layout from '@/Shared/Admin/Layout'
  import Pagination from '@/Shared/Pagination'
  import LoadingButton from '@/Shared/LoadingButton'
  import TextInput from '@/Shared/TextInput'
  import Toggle from '@/Shared/Toggle'

  export default {
    metaInfo: {title: 'Admin Roles | Create'},
    layout: Layout,
    components: {
      Icon,
      Pagination,
      LoadingButton,
      TextInput,
      Toggle
    },
    props: {
      permissions: {
        type: Object,
        required: true
      },
      model: Object,
    },

    data() {
      return {
        sending: false,
        form: {
          title: this.model.title,
          super_role: this.model.super_role,
          permissions: this.model.permissions
        }
      }
    },

    methods: {
      submit() {
        this.sending = true
        this.$inertia.put(this.route('admin.roles.update', this.model.id), this.form ,{
          onFinish : () => this.sending = false
        })
      }
    }
  }
</script>
